/**
 * Capability discovery must track what a person can currently use, not merely
 * whether a DOM node remains mounted. Keep this browser-only helper narrow so
 * actions can re-check the same condition immediately before they act.
 */
export function isWebMcpVisible(element: HTMLElement) {
  if (!element.isConnected || element.closest('[hidden], [aria-hidden="true"]')) return false;
  const styles = window.getComputedStyle(element);
  return element.getClientRects().length > 0
    && styles.display !== "none"
    && styles.visibility !== "hidden"
    && styles.visibility !== "collapse";
}
